var map = {
	"./notification-center-messages.en.json": "./src/app/shared/service/message-manager/messages/notification-center/notification-center-messages.en.json",
	"./notification-center-messages.it.json": "./src/app/shared/service/message-manager/messages/notification-center/notification-center-messages.it.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/shared/service/message-manager/messages/notification-center sync recursive ^\\.\\/notification\\-center\\-messages\\..*\\.json$";